import { HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiDataService } from "@services/http/ApiDataService";
import { Observable } from "rxjs";
import { OrganizationBudgetModel } from "./models/OrganizationBudgetModel";

@Injectable()
export class OrganizationBudgetDataService extends ApiDataService {
    constructor() {
        super("organization/budgets");
    }

    getOrgBudgets(): Observable<OrganizationBudgetModel[]> {
        return this.get<OrganizationBudgetModel[]>();
    }

    storeOrgBudgets(model: OrganizationBudgetModel[]): Observable<HttpEvent<any>> {
        return this.post(model);
    }
}
